import axios from 'axios'
import {getApiUrls,getApiUpdateUrls} from "@/http/base.http";

export function getHub(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}hub/get`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function addHub(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}hub/add`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function getByIdHub(id) {
    const { env } = getApiUrls();
    return axios.get(`${env}hub/detail/${id}`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function updateHub(payload) {
    const {envU } = getApiUpdateUrls();
    return axios.put(`${envU}hub/update`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}